import React from "react"
import CardModal, { CardModalType } from "../../modal/card-modal"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

class AccountThemeEditorComponent extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            showBox: false
        }
    }

    render() {
        return (
            <div className="admin-comment account-year-editor">
                {this.props.comment && this.props.comment !== ""
                    ? <div className="has-text-grey-lighter" title={this.props.comment}><FontAwesomeIcon icon='comments' /></div>
                    : null
                }
                <div className="admin-value-indice">
                    <div className="indice">{this.props.account.number}</div>
                    <div className="value">{this.props.value}</div>
                </div>

                <button className="add-comment" onClick={this.props.onClickViewComment}><FontAwesomeIcon icon={"plus-square"} /></button>

                {this.props.viewComment
                    && <CardModal
                        active={true}
                        paddingLess={false}
                        loading={this.props.loading}
                        title={this.props.title}
                        type={this.props.comment ? CardModalType.ValidCancelDelete : CardModalType.ValidCancel}
                        isFluid
                        onClickCloseButton={e => this.props.onClickCloseComment(e)}
                        onClickFooterButton={e => this.props.onClickCloseComment(e)}
                        onClickDeleteButton={e => this.props.onClickDeleteComment(e)}
                        onSubmit={e => this.props.onSubmit(e)}>
                        <div className="column field">
                            <label className="label">Commentaire</label>
                            <p className={`control has-icons-left ${false ? "is-loading" : ""}`}>
                                <textarea
                                    className={`textarea ${false ? "is-danger" : ""}`}
                                    disabled={this.props.loading}
                                    id={'comm'}
                                    name={'comment'}
                                    min={0}
                                    required
                                    type="text"
                                    defaultValue={this.props.comment}
                                    onChange={this.props.onChangeComment}
                                />
                            </p>
                        </div>
                    </CardModal>
                }
            </div>
        )
    }
}

export default AccountThemeEditorComponent;


// WEBPACK FOOTER //
// ./src/component/scenarii/admin/admin-account-theme-editor-component.js